import { LitElement, html } from 'lit-element';
import { repeat } from 'lit-html/directives/repeat.js';

class UnderlyingOverviewTable extends LitElement {
	static get properties() {
		return {
			items: { type: Array },
		};
	}

	render() {
		return html`
			<div class="table">
				<div class="table__body">
					${repeat(this.items, item => item.id, item => html`
						<x-underlying-overview-item class="table__row table__row--border-bottom" .data="${item}"></x-underlying-overview-item>
					`)}
				</div>
			</div>
		`;
	}

	createRenderRoot() {
		return this;
	}
}

customElements.define('x-underlying-overview-table', UnderlyingOverviewTable);

export default UnderlyingOverviewTable;
